module.exports = __webpack_public_path__ + "img/snorkeling-arrecife.296e7fdd.jpeg";